<dx-popup
  [(visible)]="displayDialog"
  width="70vw"
  height="auto"
  [maxHeight]="'85vh'"
  [resizeEnabled]="true"
  [showCloseButton]="false"
  (onHidden)="closeDialog(false)"
>
  <div *dxTemplate="let _ of 'title'" class="dialog-header">
    <div class="dialog-title">
      <yo-icon [icon]="getHeaderIcon()"></yo-icon>
      <strong>{{ title }}</strong>
    </div>

    <div class="dialog-actions">
      @if (canEdit()) {
        <yo-button
          (onClick)="initSaveFiliale()"
          iconClass="fas fa-save"
          tooltip="Enregistrer"
          [theme]="ButtonThemeEnum.SAVE"
          [disabled]="!isFormValid()">
        </yo-button>
      }
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog(false)">
      </yo-button>
    </div>
  </div>

  @if (filiale) {
    <form (ngSubmit)="initSaveFiliale()" id="filialeForm">
      <section class="dialog-content">
        <div class="dialog-column">
          <span class="dialog-section-title"><strong>Informations générales</strong></span>
          <div class="dialog-section-body">
            <div class="dialog-row">
              <span title="Site">Site <span class="danger-color">*</span></span>
              @if (isCreateMode) {
                <yo-lookup
                  #siteLookup
                  [data]="sitesList"
                  [selectedItem]="selectedSite"
                >
                </yo-lookup>
              } @else {
                <yo-text-box
                  [readonly]="true"
                  [value]="filiale.site.libelle"
                >
                </yo-text-box>
              }
            </div>

            <div class="dialog-row">
              <span title="Libellé">Libellé <span class="danger-color">*</span></span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.libelle"
                (onValueChanged)="filiale.libelle = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-row">
              <span title="Code">Code <span class="danger-color">*</span></span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.code"
                (onValueChanged)="filiale.code = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-row">
              <span title="Siret">Siret</span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.siret"
                (onValueChanged)="filiale.siret = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-row">
              <span title="Mode de règlement">Mode de règlement</span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.modeReglement"
                (onValueChanged)="filiale.modeReglement = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-row">
              <span title="Actif">Actif</span>
              <dx-check-box
                [readOnly]="!canEdit()"
                [(ngModel)]="filiale.actif"
                #actif="ngModel"
                name="actif"
              >
              </dx-check-box>
            </div>

            <div class="dialog-row">
              <span title="Secteur">Secteur <span class="danger-color">*</span></span>
              <yo-tagbox
                [readOnly]="!canEdit()"
                #secteursTagbox
                [data]="secteurList"
                [selectedItems]="editSelectedSecteurs"
              >
              </yo-tagbox>
            </div>

            <div class="dialog-row">
              <span title="Départements">Départements</span>
              <yo-multiselect
                [data]="departementListEnriched"
                displayValue="nom"
                [groupFn]="groupDepartementByRegion"
                [selectedItems]="selectedDepartements"
                [searchExpr]="['nom', 'code', 'regionNom', 'regionCode']"
                placeholder="Sélectionner des départements"
                [expandedGroups]="false"
                (onValueChange)="onDepartementsChange($event)"
              ></yo-multiselect>
            </div>

            <div class="dialog-row">
              <span title="Frais de port">Frais de port</span>
              <dx-check-box
                [readOnly]="!canEdit()"
                [(ngModel)]="filiale.francoDePortActif"
                #francoDePortActif="ngModel"
                name="francoDePortActif"
              >
              </dx-check-box>
            </div>

            @if (filiale.francoDePortActif) {
              <div class="dialog-row">
                <span title="Coût des frais de port">Coût des frais de port</span>
                <div class="dialog-input-row">
                  <yo-text-box
                    [readonly]="!canEdit()"
                    [value]="filiale.francoDePortCout?.toString()"
                    (onValueChanged)="filiale.francoDePortCout = +$event"
                  >
                  </yo-text-box>
                  <span class="dialog-unit">€</span>
                </div>
              </div>

              <div class="dialog-row">
                <span title="Montant HT minimal">Montant HT minimal</span>
                <div class="dialog-input-row">
                  <yo-text-box
                    [readonly]="!canEdit()"
                    [value]="filiale.francoDePortMontant?.toString()"
                    (onValueChanged)="filiale.francoDePortMontant = +$event"
                  >
                  </yo-text-box>
                  <span class="dialog-unit">€</span>
                </div>
              </div>

              <div class="dialog-row">
                <span title="Poids minimal">Poids minimal</span>
                <div class="dialog-input-row">
                  <yo-text-box
                    [readonly]="!canEdit()"
                    [value]="filiale.francoDePortPoids?.toString()"
                    (onValueChanged)="filiale.francoDePortPoids = +$event"
                  >
                  </yo-text-box>
                  <span class="dialog-unit">KG</span>
                </div>
              </div>

              <div class="dialog-row">
                <span title="TVA frais de port">TVA frais de port</span>
                <div class="dialog-input-row">
                  <yo-text-box
                    [readonly]="!canEdit()"
                    [value]="filiale.francoDePortTva?.toString()"
                    (onValueChanged)="filiale.francoDePortTva = +$event"
                  >
                  </yo-text-box>
                  <span class="dialog-unit">%</span>
                </div>
              </div>
            }

            <div class="dialog-row">
              <span title="Référencement">Référencé</span>
              <dx-check-box
                [readOnly]="!canEdit()"
                [(ngModel)]="filiale.referencement"
                #referencement="ngModel"
                name="referencement"
              >
              </dx-check-box>
            </div>
          </div>
        </div>

        <div class="dialog-column">
          <span class="dialog-section-title"><strong>Adresse</strong></span>
          <div class="dialog-section-body dialog-address-body">
            <div class="dialog-address-split">
              <div class="dialog-row">
                <span title="Nom de l'adresse">Nom de l'adresse</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.nom"
                  (onValueChanged)="filiale.adresse.nom = $event"
                >
                </yo-text-box>
              </div>

              <div class="dialog-row">
                <span title="Code Postal">Code Postal</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.codePostal"
                  (onValueChanged)="filiale.adresse.codePostal = $event"
                >
                </yo-text-box>
              </div>

              <div class="dialog-row">
                <span title="Nom du contact">Nom du contact</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.nomContact"
                  (onValueChanged)="filiale.adresse.nomContact = $event"
                >
                </yo-text-box>
              </div>

              <div class="dialog-row">
                <span title="Ville">Ville</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.ville"
                  (onValueChanged)="filiale.adresse.ville = $event"
                >
                </yo-text-box>
              </div>

              <div class="dialog-row">
                <span title="Téléphone">Téléphone</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.telephone"
                  (onValueChanged)="filiale.adresse.telephone = $event"
                >
                </yo-text-box>
              </div>

              <div class="dialog-row">
                <span title="Fax">Fax</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.fax"
                  (onValueChanged)="filiale.adresse.fax = $event"
                >
                </yo-text-box>
              </div>
            </div>

            <div class="dialog-row">
              <span title="Adresse 1">Adresse 1</span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.adresse.adresse1"
                (onValueChanged)="filiale.adresse.adresse1 = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-row">
              <span title="Adresse 2">Adresse 2</span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.adresse.adresse2"
                (onValueChanged)="filiale.adresse.adresse2 = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-row">
              <span title="Adresse 3">Adresse 3</span>
              <yo-text-box
                [readonly]="!canEdit()"
                [value]="filiale.adresse.adresse3"
                (onValueChanged)="filiale.adresse.adresse3 = $event"
              >
              </yo-text-box>
            </div>

            <div class="dialog-subsection">
              <span class="dialog-subsection-title">Envoi des commandes</span>
              <div class="dialog-row">
                <span title="Email 1">Email 1</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.adresse.email"
                  (onValueChanged)="filiale.adresse.email = $event"
                >
                </yo-text-box>
              </div>
              <div class="dialog-row">
                <span title="Email 2">Email 2</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.emailCommande"
                  (onValueChanged)="filiale.emailCommande = $event"
                >
                </yo-text-box>
              </div>
            </div>

            <div class="dialog-subsection">
              <span class="dialog-subsection-title">Envoi des factures et avoirs</span>
              <div class="dialog-row">
                <span title="Email 1">Email 1</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.emailFacturation1"
                  (onValueChanged)="filiale.emailFacturation1 = $event"
                >
                </yo-text-box>
              </div>
              <div class="dialog-row">
                <span title="Email 2">Email 2</span>
                <yo-text-box
                  [readonly]="!canEdit()"
                  [value]="filiale.emailFacturation2"
                  (onValueChanged)="filiale.emailFacturation2 = $event"
                >
                </yo-text-box>
              </div>
            </div>
          </div>
        </div>
      </section>
    </form>
  }
</dx-popup>
